module.exports = __webpack_public_path__ + "static/assets/mdi_light_camera.svg";